import { groupBy, keyBy, sortBy } from 'lodash';
import { Reducer } from 'redux';
import { CompanyMap, withCompany } from 'utils/companyDux';
import { ActionTypes, TokenBuilderAction } from './actions';
import { TokenBuilderState } from './interfaces';

export const initialBuilderState: TokenBuilderState = {
    arcadeList: [],
    count: 1,
    recognitionDistributionsSelected: {},
    recipientIds: [],
    recipients: {},
    roomsByArcadeId: {},
    roomsById: {},
    validationErrors: {},
};

export const tokenBuilderReducer: Reducer<CompanyMap<TokenBuilderState>, TokenBuilderAction> = withCompany((
    state: TokenBuilderState = initialBuilderState,
    action: TokenBuilderAction,
): TokenBuilderState => {
    switch (action.type) {

        case ActionTypes.SET_ARCADE_LIST: {
            const sortedRooms = sortBy(action.roomList, [room => room.freePlay, room => room.name]);
            const roomsByArcadeId = groupBy(sortedRooms, room => room.arcadeId);
            const roomsById = keyBy(action.roomList, room => room.id);

            return {
                ...state,
                arcadeList: action.arcadeList,
                roomsByArcadeId,
                roomsById,
            };
        }

        case ActionTypes.SET_FORM_FIELDS: {
            const validationErrors = { ...state.validationErrors };
            for (const fieldName of Object.keys(action.fields)) {
                delete validationErrors[fieldName];
            }

            return {
                ...state,
                ...action.fields,
                validationErrors,
            };
        }

        case ActionTypes.SET_RECOGNITION_DISTRIBUTION_SELECTION:
            return {
                ...state,
                recognitionDistributionsSelected: {
                    ...state.recognitionDistributionsSelected,
                    [action.recognitionDistributionId]: action.value,
                },
            };

        case ActionTypes.SET_VALIDATION_ERRORS:
            return {
                ...state,
                validationErrors: action.validationErrors
            };
    }

    return state;
});
